var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prSubsc"},[_c('img',{staticClass:"prSubsc__copy",attrs:{"src":_vm.imgPath + 'subsc_copy_second_half.png',"alt":"占いTV 月額会員になれば"}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.sbscUrl}},[_c('img',{staticClass:"prSubsc__banner",attrs:{"src":_vm.imgPath + 'subsc_banner.png',"alt":"見放題で見る"}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a63d00","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/YearLuck/y2022/prSubsc.vue
// module id = null
// module chunks = 